<template>
  <DeleteConfirm
      itemKey="TicketItemOffer"
      :fetchData="fetchData"
      :setTitle="setTitle"
      :setQuestion="setQuestion"
      :deleteData="deleteData"
      @onDelete="(response) => $emit('onDelete', response)"
      v-bind="$attrs"
  />
</template>

<script>
  import TicketItemOffers from '@/services/ticket-item-offers'

  import DeleteConfirm from '@/components/_Part/_Modal/_Confirm/Delete'

  export default {
    name: 'Delete',
    props: [
      'id'
    ],
    emits: [
      'onDelete'
    ],
    components: {
      DeleteConfirm
    },
    methods: {
      fetchData() {
        return TicketItemOffers
          .read({
            id: this.id
          })
      },
      setTitle(Item) {
        return 'Odstrániť ponuku "' + Item.User.name + '"'
      },
      setQuestion(Item) {
        return 'Naozaj chcete odstrániť ponuku "' + Item.User.name + '"?'
      },
      deleteData() {
        return TicketItemOffers
          .delete({
            id: this.id
          })
      }
    }
  }
</script>
